<template>
	<a
		:href="link"
		target="_self"
		class="team_member_list_item"
	>
		<div class="image">
			<img
				v-if="image"
				v-lazy="image"
				class="lazy"
				:alt="title"
			/>
			<img
				v-else
				v-lazy="sampleImage"
				class="lazy sample"
				:alt="title"
			/>
		</div>
		<span class="content">
			<div class="title">
				<h3
					v-if="title"
					v-html="title"
				></h3>
			</div>

			<p v-if="text">
				<span v-html="text"></span>
				<span class="read_more">Read more...</span>
			</p>
		</span>
	</a>
</template>

<script>
import SampleImage from '../../images/scroll_logo.png';

export default {
	data() {
		return {
			sampleImage: SampleImage,
		};
	},

	props: {
		image: {
			default: SampleImage,
		},
		title: {},
		text: {},
		link: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.team_member_list_item {
	display: grid;
	grid-template-rows: auto;
	text-decoration: none;


	@media (max-width: $lg) {
		padding: $spacer $spacer 0;
		margin-bottom: $spacer;
	}

	&:hover {
		cursor: pointer;

		.image {
			img {
				transform: scale(1.1);
				transition: 0.2s ease all;
			}
		}

		.title {
			.arrow {
				svg {
					left: 30px;
					transition: 0.2s ease all;

					@media (max-width: $lg) {
						left: 0;
					}
				}
			}
		}
	}

	.image {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		height: 330px;
		overflow: hidden;
		background: $cpmec-grey;

		@media (max-width: $lg) {
			height: 223px;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			margin: 0;
			transition: 0.2s ease all;

			&.sample {
				object-fit: contain;
				max-width: 70px;
				margin: 0 auto;
				filter: grayscale(1);
			}

			@media (max-width: $lg) {
				max-height: 240px;
			}
		}
	}

	.content {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		min-height: 175px;
		margin-top: $spacer;

		@media (max-width: $lg) {
		min-height: auto;
	}
	}

	.title {
		display: grid;
		grid-template-columns: 1fr;
		column-gap: $spacer * 2;
		// margin-top: $spacer;

		@media (max-width: $lg) {
			grid-template-columns: 1fr;
			column-gap: $spacer;
		}

		h3 {
			color: $cpmec-blue;
			margin: 0;
			font-size: 28px;
			line-height: 38px;
			font-family: $font-family;
			font-weight: normal;

			@media (max-width: $lg) {
				font-size: 22px;
				line-height: 32px;
			}
		}

		.arrow {
			position: relative;
			display: flex;
			flex-direction: row;
			align-items: center;
			margin-top: $spacer / 2;
			width: 70px;
			height: 20px;
			transition: 0.2s ease all;

			svg {
				position: absolute;
				left: 0;
				right: 0;
				transition: 0.2s ease all;

				path {
					fill: $cpmec-blue;
				}
			}
		}
	}

	p {
		margin: $spacer 0 0;

		span {
			color: $cpmec-grey;
			margin: 0;
			font-size: 20px;

			@media (max-width: $lg) {
				font-size: 18px;
			}

			&.read_more {
				color: $cpmec-blue;
				margin: 0;
				font-size: 20px;
				margin-left: $spacer / 2;

				@media (max-width: $lg) {
					font-size: 18px;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/TeamMemberListItem.vue